<section class="feedback-area ptb-100" id="appSpotlight">
    <div class="container" style="max-width: 1000px;">
        <div class="row align-items-center">
            <img src="/assets/img/sr/AppBannerTransparent.png" alt="">
        </div>
    </div>
</section>